var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("loader", { attrs: { "is-loading": _vm.isLoading } }, [
    _c(
      "div",
      [
        _c(
          "v-tabs",
          {
            attrs: {
              "active-class": "primary--text",
              height: _vm.FRI_TABS_HEIGHT + 20,
              "background-color":
                _vm.$vuetify.theme.themes[_vm.theme].background,
              grow: "",
              "show-arrows": ""
            },
            model: {
              value: _vm.period,
              callback: function($$v) {
                _vm.period = $$v
              },
              expression: "period"
            }
          },
          [
            _c(
              "v-tab",
              [
                _c("button-icon", {
                  attrs: {
                    "icon-text": "24h",
                    label: "Sur 24 Heures",
                    active: _vm.period === 0,
                    badge: _vm.displayed[0] ? "!" : null
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-tab",
              [
                _c("button-icon", {
                  attrs: {
                    "icon-text": "15j",
                    label: "Sur 15 Jours",
                    active: _vm.period === 1,
                    badge: _vm.displayed[1] ? "!" : null
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-tab",
              [
                _c("button-icon", {
                  attrs: {
                    icon: "mdi-account-details",
                    label: "Par Appelant",
                    active: _vm.period === 2,
                    badge: _vm.displayed[2] ? "!" : null
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "v-tabs-items",
          {
            style: {
              background: _vm.$vuetify.theme.themes[_vm.theme].background
            },
            model: {
              value: _vm.period,
              callback: function($$v) {
                _vm.period = $$v
              },
              expression: "period"
            }
          },
          [
            _c("v-tab-item", [
              _vm.data_24h.length > 1
                ? _c(
                    "div",
                    {
                      staticClass: "d-flex flex-wrap",
                      staticStyle: {
                        "max-height": "300px",
                        "overflow-y": "auto"
                      }
                    },
                    _vm._l(_vm.count_24h, function(item) {
                      return _c(
                        "div",
                        {
                          key: item.code,
                          staticClass: "d-flex align-center flex-nowrap my-2"
                        },
                        [
                          _c("number-badge", {
                            attrs: {
                              label: item.name,
                              number: item.count,
                              value: _vm.detail && item.code === _vm.detail.code
                            },
                            on: {
                              click: function($event) {
                                return _vm.showDetail(item)
                              }
                            }
                          })
                        ],
                        1
                      )
                    }),
                    0
                  )
                : _c("div", { staticClass: "caption mt-2" }, [
                    _vm._v(
                      "\n          Pas de données sur la période\n        "
                    )
                  ])
            ]),
            _vm._v(" "),
            _c("v-tab-item", [
              _vm.data_15d.length > 1
                ? _c(
                    "div",
                    [
                      _c(
                        "div",
                        {
                          staticClass: "d-flex flex-wrap",
                          staticStyle: {
                            "max-height": "300px",
                            "overflow-y": "auto"
                          }
                        },
                        _vm._l(_vm.sortedData_15d, function(item) {
                          return _c(
                            "div",
                            {
                              key: item.status,
                              staticClass:
                                "d-flex align-center flex-nowrap my-2"
                            },
                            [
                              _c("number-badge", {
                                attrs: {
                                  label: _vm.displayName(item),
                                  number: item.list.length,
                                  value:
                                    _vm.detail &&
                                    item.rejected === _vm.detail.rejected &&
                                    item.status === _vm.detail.status
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.showDetail(item)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _vm.detail &&
                      (_vm.detail.status === "5" || _vm.detail.status === "9")
                        ? _c(
                            "v-card",
                            { attrs: { rounded: "", color: "background" } },
                            [
                              _c(
                                "div",
                                { staticClass: "d-flex flex-wrap" },
                                _vm._l(_vm.expandedFinished, function(req) {
                                  return _c(
                                    "div",
                                    {
                                      key: req.reason,
                                      staticClass:
                                        "d-flex align-center flex-nowrap my-2"
                                    },
                                    [
                                      _c("number-badge", {
                                        attrs: {
                                          label: _vm.displayName(req),
                                          number: req.list.length,
                                          value:
                                            _vm.expand.length &&
                                            _vm.expand.some(
                                              item => req.reason === item.reason
                                            )
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.showExpand(req)
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  )
                                }),
                                0
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _c("div", { staticClass: "caption mt-2" }, [
                    _vm._v(
                      "\n          Pas de données sur la période\n        "
                    )
                  ])
            ]),
            _vm._v(" "),
            _c("v-tab-item", [
              _vm.customer_15d.length > 0
                ? _c(
                    "div",
                    {
                      staticClass: "d-flex flex-wrap",
                      staticStyle: {
                        "max-height": "300px",
                        "overflow-y": "auto"
                      }
                    },
                    _vm._l(_vm.customer_15d, function(item) {
                      return _c(
                        "div",
                        {
                          key: item.name,
                          staticClass: "d-flex align-center flex-nowrap my-2"
                        },
                        [
                          _c("number-badge", {
                            attrs: {
                              label: item.name,
                              number: item.count,
                              value: _vm.detail && item.name === _vm.detail.name
                            },
                            on: {
                              click: function($event) {
                                return _vm.showDetail(item)
                              }
                            }
                          })
                        ],
                        1
                      )
                    }),
                    0
                  )
                : _c("div", { staticClass: "caption mt-2" }, [
                    _vm._v(
                      "\n          Pas de données sur la période\n        "
                    )
                  ])
            ])
          ],
          1
        ),
        _vm._v(" "),
        _vm.detail
          ? _c("div", { staticClass: "info--text my-3 mt-2 ml-4" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm._f("capitalize")(_vm.tableTitle)) +
                  " :\n    "
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.detail
          ? _c("requests-recurrence-table", {
              staticClass: "mx-auto",
              attrs: { data: _vm.tableData, onlyClosed: this.period === 1 }
            })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }